<div class="header-container">
  <h3 class="header-title">Tenants</h3>
  <div class="header-actions-container">
    <nz-select nzMode="multiple" nzPlaceHolder="Filters" nzSize="large" nzAllowClear
      [ngModel]="selectedFilters" (ngModelChange)="onFiltersChange($event)"
      [nzMaxTagCount]="2" [nzLoading]="isDevModeLoading" style="min-width: 260px">
      <nz-option-group nzLabel="Statistics">
        <nz-option nzLabel="Mixpanel Excluded" nzValue="stats-excluded"></nz-option>
        <nz-option nzLabel="Mixpanel Included" nzValue="stats-included"></nz-option>
      </nz-option-group>
      <nz-option-group nzLabel="Decision-maker email">
        <nz-option nzLabel="Decision Email Set" nzValue="email-set"></nz-option>
        <nz-option nzLabel="Decision Email Missing" nzValue="email-not-set"></nz-option>
      </nz-option-group>
      <nz-option-group nzLabel="Dev mode">
        <nz-option nzLabel="Dev mode On" nzValue="dev-on"></nz-option>
      </nz-option-group>
    </nz-select>
    <search-input
      [placeholder]="'Search tenant'"
      (searchValue)="handleSearchClick($event)"
    ></search-input>
    <button nz-button nzSize="large" nzType="primary" nzDanger
            (click)="customerCreateLink()">
      <span nz-icon nzType="plus" nzTheme="outline"></span>
      Add new tenant
    </button>
  </div>
</div>
<div class="content">
  <div *ngIf="isLoading" class="loader-container">
    <nz-spin nzSimple [nzSize]="'large'"></nz-spin>
  </div>
  <nz-table
    #customersTable
    [nzData]="hasActiveFilters ? filteredListOfCustomers : (listOfCustomers | sortBy: 'company_name')"
    class="yoma-table"
    id="group-table"
    [nzFrontPagination]="true"
    [nzPageSize]="10"
    [nzPaginationType]="'small'"
    [nzShowPagination]="true"
    (nzPageIndexChange)="onPageIndexChange()"
    [nzShowTotal]="rangeTemplate"
    [nzTotal]="hasActiveFilters ? filteredListOfCustomers.length : listOfCustomers.length"
  >
    <thead>
    <tr>
      <th>Tenant</th>
      <th>Billing address</th>
      <th>Contact</th>
      <th>Admin</th>
      <th style="width: 150px">User vs. Possible</th>
      <th>KeyAccount</th>
      <th style="width: 120px">Active l30d</th>
      <th style="max-width: 100px"></th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let data of customersTable.data" (click)="customerLink(data)" class="data-row">
      <td>
        <div class="item-container">
          <span nz-typography>{{ data.company_name }}</span>
        </div>
      </td>
      <td>
        <div class="item-container">
          <span nz-typography>{{ data.billing_address_street }} {{data.billing_address_street_no}}</span>
          <span nz-typography>{{ data.billing_address_zip_code }} {{data.billing_address_city}}</span>
        </div>
      </td>
      <td>
        <div class="item-container">
          <span nz-typography>{{ data.contact_name }}</span>
          <span nz-typography nzType="danger">{{ data.contact_email }}</span>
        </div>
      </td>
      <td>
        <div class="item-container">
          <span nz-typography>{{ data.admin_name }}</span>
          <span nz-typography nzType="danger">{{ data.admin_email }}</span>
        </div>
      </td>
<!--      <td>-->
<!--        <div class="item-container">-->
<!--          <div *ngIf="data.pk | tenantUserStatistics: data.employees | async as statistics; else loading">-->
<!--            {{ statistics }}-->
<!--          </div>-->
<!--          <ng-template #loading>-->
<!--            <nz-spin nzSimple></nz-spin>-->
<!--          </ng-template>-->
<!--        </div>-->
<!--      </td>-->
      <td>
        <div class="item-container">
          <div *ngIf="data.pk | tenantUserStatistics | async as stats; else loading">
            {{ stats.verified_users }} vs. [{{ data.employees || '...' }}] =
            {{ data.employees
            ? ((stats.verified_users / data.employees * 100) | number:'1.0-0')
            : '.....' }}%
          </div>
          <ng-template #loading>
            <nz-spin nzSimple></nz-spin>
          </ng-template>
        </div>
      </td>
      <td>
        <div class="item-container">
          <div *ngIf="data.pk | tenantUserStatistics | async as stats; else loading">
            {{ stats.key_account_users }}
          </div>
        </div>
      </td>
      <td>
        <div class="item-container">
          <div *ngIf="data.pk | tenantUserStatistics | async as stats; else loading">
            {{ stats.active_users }}/{{ stats.total_users }}
            ({{ stats.total_users
            ? ((stats.active_users / stats.total_users * 100) | number:'1.0-0')
            : '...' }}%)
          </div>
        </div>
      </td>
      <td (click)="$event.stopPropagation()">
        <div class="actions-container">
          <button nz-button nzType="default" nzShape="circle"
                  (click)="openCustomerDeleteModal(tplDeleteModal, tplDeleteModalFooter, data.pk)">
            <span nz-icon nzType="delete" nzTheme="outline"></span>
          </button>
        </div>
      </td>
    </tr>
    </tbody>
  </nz-table>
  <ng-template #rangeTemplate let-range="range" let-total>
    @if(hasActiveFilters) {
      filtered {{total}} of {{ listOfCustomers.length }} tenants total
    } @else {
      {{ listOfCustomers.length }} tenants total
    }
  </ng-template>

</div>

<ng-template #tplDeleteModal>
  <p>
    This will <b>permanently remove</b> the tenant <b>{{customer.company_name}}</b> and all of its associated
    data and orders from the system. This cannot be undone.

  </p>
  <p>Enter “Delete” and the tenants name into the field below to proceed:</p>
  <form nz-form>
    <nz-form-item>
      <nz-form-control nzHasFeedback nzErrorTip="Feature name is required">
        <input class="form-item-bordered" nz-input [(ngModel)]="deleteTextValue" name="feature_delete_text"
               required="true" [placeholder]="'Delete ' + customer.company_name"/>
      </nz-form-control>
    </nz-form-item>
  </form>
</ng-template>

<ng-template #tplDeleteModalFooter let-ref="modalRef">
  <button nz-button (click)="handleModalClose(ref)" class="form-button">Cancel</button>
  <button nz-button (click)="deleteCustomer(ref, customer.pk)" class="form-button" nzType="primary" nzDanger
          [disabled]="deleteTextValue.toLowerCase() != deleteText.toLowerCase()">Delete
  </button>
</ng-template>
